import React from 'react'
import PropTypes from 'prop-types'
import {Button, Flex, Text, useStyleConfig} from '@chakra-ui/react'
import {ChevronRightIcon} from '../../icons'
import {Link} from 'react-router-dom'
import useDamImage from '../../../custom-hooks/use-dam-image'
import {getGlobalLink} from '../../../utils/contentstack-utils'
import {useProducts} from '@salesforce/commerce-sdk-react'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const PlpGridCard = ({title, redirects, images, colSpan = 1, categoriesData}) => {
    const styles = useStyleConfig('PlpGridCard')
    const {locale} = useMultiSite()

    const damImage = useDamImage(images)
    const {data: productsData} = useProducts({
        parameters: {
            ids: redirects?.productsfcc?.data?.length > 0 ? redirects.productsfcc.data[0].id : '',
            allImages: false,
        },
    })
    const {url, label, isAbsolute} = getGlobalLink({
        link: redirects,
        categoriesData,
        productsData,
        locale: locale?.alias || locale?.id?.toLowerCase(),
    })

    const buttonProps = isAbsolute
        ? {
              as: 'a',
              href: url,
              target: '_blank',
              rel: 'noopener noreferrer',
          }
        : {
              as: Link,
              to: url,
          }

    return (
        <Flex
            {...styles.container}
            gridColumn={`span ${colSpan}`}
            background={
                damImage?.url
                    ? `linear-gradient(180deg, rgba(0, 0, 0, 0.00) 21.28%, rgba(0, 0, 0, 0.70) 90.43%), url(${damImage.url}) lightgray 50% / cover no-repeat`
                    : 'none'
            }
        >
            <Text {...styles.title}>{title}</Text>
            {label && url && (
                <Button
                    {...buttonProps}
                    {...styles.button}
                    variant="inverse-icon-button"
                    rightIcon={<ChevronRightIcon />}
                >
                    {label}
                </Button>
            )}
        </Flex>
    )
}

PlpGridCard.propTypes = {
    title: PropTypes.string,
    images: PropTypes.object,
    redirects: PropTypes.object,
    categoriesData: PropTypes.object,
    colSpan: PropTypes.number,
}

export default PlpGridCard
